module.exports = __webpack_public_path__ + "img/icon_zb.a047a32b.png";